import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface PdiDashboard {
  kpis: {
    totalOrders: number; orderValue: number; ordersInFulfilment: number; ordersDelivered: number;
    installationsOpen: number; installationSla: number; outstandingReceivable: number; overdueReceivable: number;
    activeDealers: number; totalDealers: number;
  };
  orders: { totalOrders: number; totalValue: number; pendingApproval: number; inFulfilment: number; delivered: number; open: number; byStatus: Record<string, number>; monthlyTrend: { month: string; count: number; value: number }[] };
  installations: { total: number; pending: number; ongoing: number; completed: number; materialReady: number; slaBreached: number; slaPerformance: number; overdue: number };
  finance: { totalInvoiceValue: number; paidAmount: number; outstandingAmount: number; overdueAmount: number; ageing: { label: string; value: number }[] };
  dealers: { total: number; active: number; pendingApproval: number; creditExposure: number };
}

export const pdiDashboardApi = {
  async overview(params?: { from?: string; to?: string; regionId?: number; dealerId?: number; status?: string }): Promise<PdiDashboard> {
    return (await apiClient.get<ApiSuccess<PdiDashboard>>('/pdi-dashboard', { params })).data.data;
  },
};
